<template>
  <div class="mr-1 flex" :class="footer ? 'mb-2.5' : ''">
    <a class="flex text-white hover:text-var(--color-primary-500)" target="_blank" :href="youtube">
      <VcIcon name="youtube" class="mr-2 text-white" :size="18" lazy />

      <span class="sr-only">youtube</span>
    </a>
  </div>

  <div class="mr-1 flex" :class="footer ? 'mb-2.5' : ''">
    <a class="flex text-white hover:text-var(--color-primary-500)" target="_blank" :href="linkedin">
      <VcIcon name="linkedin" class="mr-2 text-white" :size="18" lazy />

      <span class="sr-only">linkedin</span>
    </a>
  </div>

  <div class="mr-1 flex" :class="footer ? 'mb-2.5' : ''">
    <a class="flex text-white hover:text-var(--color-primary-500)" target="_blank" :href="phoneNumber">
      <VcIcon name="phone-contact" class="mr-2 text-white" :size="16" lazy />

      <span class="sr-only">Call us</span>
    </a>
  </div>

  <div class="mr-1 flex" :class="footer ? 'mb-2.5' : ''">
    <a class="flex text-white hover:text-var(--color-primary-500)" target="_blank" :href="mail">
      <VcIcon name="mail" class="mr-2 text-white" :size="16" lazy />

      <span class="sr-only">mail us</span>
    </a>
  </div>
</template>

<script setup lang="ts">
import { globals } from "@/core/globals";
import { computed } from "vue";

defineProps({
  footer: {
    type: Boolean,
    default: false,
  },
});

const { storeId } = globals;

// Custom Innovadis quick fix theme settings
const youtube = computed<string>(() => "https://www.youtube.com/@herasmobile");
const linkedin = computed<string>(() =>
  storeId === "HerasFR"
    ? "https://www.linkedin.com/company/heras-cloture"
    : "https://www.linkedin.com/company/heras-mobile-fencing-&-security",
);

const phoneNumber = computed<string>(() =>
  storeId === "HerasBE"
    ? "tel:+32 (0)13 677 834"
    : storeId === "HerasFR"
      ? " tel:+33 (0)474 36 67 11"
      : "tel:+31 (0)499 551 551",
);

const mail = computed<string>(() =>
  storeId === "HerasBE"
    ? "mailto:info@heras-mobile.be"
    : storeId === "HerasFR"
      ? "mailto:info@heras-mobile.fr"
      : "mailto:info@heras-mobile.nl",
);
</script>
